import React from 'react';
import Herosection from '../../components/home/Herosection';
import HomeCategory from '../../components/home/HomeCategory';

const Home = () => {
    return (
        <>
            <Herosection />
            <HomeCategory />
        </>
    );
};

export default Home;